import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "react-oidc-context";

export default function AdminLayout() {
  const auth = useAuth();
  const username =
    (auth.user?.profile?.preferred_username as string | undefined) ??
    auth.user?.profile?.email ??
    "—";

  return (
    <div className="mt-shell">
      <header className="mt-topbar">
        <Link to="/" className="mt-topbar__brand">
          <span className="mt-topbar__mark">m</span>medtranslate / admin
        </Link>
        <nav className="mt-topbar__nav">
          <NavLink
            to="/admin/overview"
            className={({ isActive }) =>
              "mt-tab" + (isActive ? " is-active" : "")
            }
          >
            Обзор
          </NavLink>
          <NavLink
            to="/admin/review"
            className={({ isActive }) =>
              "mt-tab" + (isActive ? " is-active" : "")
            }
            end
          >
            Очередь
          </NavLink>
          <NavLink
            to="/admin/review/batch"
            className={({ isActive }) =>
              "mt-tab" + (isActive ? " is-active" : "")
            }
          >
            Bulk
          </NavLink>
          <NavLink
            to="/admin/terminology"
            className={({ isActive }) =>
              "mt-tab" + (isActive ? " is-active" : "")
            }
          >
            Терминология
          </NavLink>
          <NavLink
            to="/admin/feedback"
            className={({ isActive }) =>
              "mt-tab" + (isActive ? " is-active" : "")
            }
          >
            Замечания
          </NavLink>
          <NavLink
            to="/admin/llm-jobs"
            className={({ isActive }) =>
              "mt-tab" + (isActive ? " is-active" : "")
            }
          >
            LLM Jobs
          </NavLink>
          <NavLink
            to="/admin/api-tokens"
            className={({ isActive }) =>
              "mt-tab" + (isActive ? " is-active" : "")
            }
          >
            API-токены
          </NavLink>
          <NavLink
            to="/admin/api-log"
            className={({ isActive }) =>
              "mt-tab" + (isActive ? " is-active" : "")
            }
          >
            API-лог
          </NavLink>
          <NavLink
            to="/admin/backups"
            className={({ isActive }) =>
              "mt-tab" + (isActive ? " is-active" : "")
            }
          >
            Бэкапы
          </NavLink>
          <NavLink
            to="/admin/styleguide"
            className={({ isActive }) =>
              "mt-tab" + (isActive ? " is-active" : "")
            }
          >
            Styleguide
          </NavLink>
          <NavLink
            to="/translate"
            className={({ isActive }) =>
              "mt-tab" + (isActive ? " is-active" : "")
            }
          >
            Перевод
          </NavLink>
        </nav>
        <div className="mt-topbar__right">
          <span className="mt-topbar__user">{username}</span>
          <button
            className="mt-btn mt-btn--ghost mt-btn--sm"
            onClick={() => void auth.signoutRedirect()}
          >
            Выйти
          </button>
        </div>
      </header>
      <main className="mt-main">
        <Outlet />
      </main>
    </div>
  );
}
